export default __webpack_public_path__ + "static/media/imgs1.391428ed.png";